import { render, staticRenderFns } from "./SafeForWorkOption.vue?vue&type=template&id=1f491013&scoped=true&"
import script from "./SafeForWorkOption.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkOption.vue?vue&type=script&lang=ts&"
import style0 from "./SafeForWorkOption.vue?vue&type=style&index=0&id=1f491013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f491013",
  null
  
)

export default component.exports